<template>
  <TrfModal 
    :isBtnLoading="isLoading" 
    :isModalActive="isAberto" 
    :isBtnOkDisabled="!dataVigencia"
    @save="confirmar" 
    @close="close" 
    btnSaveName="Confirmar" 
    btnCloseName="Cancelar" 
    titulo="Definição do período de vigência:"
    class="modal-periodo-vigencia"
  >
    <div class="columns">
      <div class="column is-two-fifths">
        <b>
          Informe o período em que entrarão em vigor as novas alterações:
        </b>
      </div>
      <div class="column is-one-third">
        <TrfInput
          type="date"
          placeholder="Data de vigência"
          id="data-vigencia"
          v-model="dataVigencia"
          ref="dataVigencia"
          v-e2e="'input-data-vigencia'"
        />
      </div>
    </div>
  </TrfModal>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
  name: 'ModalPeriodoVigencia',
  components: {
    TrfModal: defineAsyncComponent(() => import('../../../../components/Modal')),
    TrfInput: defineAsyncComponent(() => import('../../../../components/Input'))
  },
  emits: ['close', 'save'],
  props: {
    isAberto: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataVigencia: null
    }
  },
  methods: {
    close() {
      this.$refs.dataVigencia?.limparInput();
      this.dataVigencia = null;
      this.$emit('close');
    },
    confirmar() {
      if(!this.dataVigencia) {
        return;
      }
      this.$emit('save', this.dataVigencia);
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 769px) {
  .modal-periodo-vigencia .columns {
    margin-bottom: 0;
    margin-top: 0;
  }
}
</style>

<style lang="scss">
@media screen and (min-width: 769px) {
  .modal-periodo-vigencia .modal-card {
    width: 700px;
  }
}
</style>